import React from 'react';
import { useIntl } from 'react-intl';

import { Option, Select } from 'carbon-react/lib/components/select';

import { Recurrence } from '../hooks/useScheduleReportForm';

interface RecurrenceSelectProps {
  value: Recurrence;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RecurrenceSelect = ({ value, onChange }: RecurrenceSelectProps) => {
  const intl = useIntl();

  return (
    <Select
      id="schedule-report-recurrence"
      name="schedule-report-recurrence"
      label={intl.formatMessage({ id: 'common.repeat', defaultMessage: 'Repeat' })}
      value={value}
      onChange={onChange}
      required
      mb={0}
    >
      <Option
        text={intl.formatMessage({ id: 'reporting.recurrence_does_not_repeat', defaultMessage: 'Does not repeat' })}
        value={Recurrence.DOES_NOT_REPEAT}
      />
      <Option
        text={intl.formatMessage({ id: 'common.recurrence_daily', defaultMessage: 'Daily' })}
        value={Recurrence.DAILY}
      />
      <Option text={intl.formatMessage({ id: 'common.weekly', defaultMessage: 'Weekly' })} value={Recurrence.WEEKLY} />
      <Option
        text={intl.formatMessage({ id: 'common.monthly', defaultMessage: 'Monthly' })}
        value={Recurrence.MONTHLY}
      />
      <Option
        text={intl.formatMessage({ id: 'common.quarterly', defaultMessage: 'Quarterly' })}
        value={Recurrence.QUARTERLY}
      />
      <Option
        text={intl.formatMessage({ id: 'common.annually', defaultMessage: 'Annually' })}
        value={Recurrence.ANNUALLY}
      />
    </Select>
  );
};
